import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';
import quoteService from 'services/quoteService';

import { fetchProfile } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import { isCompleteExpedite } from 'utils/quoteUtils';

import {
  fetchGlobalExpediteOptions,
  types,
  updateExpediteSettings,
} from './actions';
import { getGlobalExpediteOptions } from './reducer';

export default function* root() {
  yield takeLatest(
    types.UPDATE_EXPEDITE_SETTINGS_REQUEST,
    watchUpdateExpediteSettings,
  );
}

function* watchFetchGlobalExpediteOptions() {
  try {
    const groupId = yield select(getGroupId);
    const globalExpediteOptions = yield call(
      quoteService.getGlobalExpediteOptions,
      groupId,
    );
    yield put(fetchGlobalExpediteOptions.success({ globalExpediteOptions }));
  } catch (error) {
    console.error('FAILED TO FETCH GLOBAL EXPEDITE OPTIONS', error);
    yield put(fetchGlobalExpediteOptions.error(error));
  }
}

function* watchUpdateExpediteSettings(action) {
  try {
    const { expediteOptions, standardLeadTime } = action.payload;
    const groupId = yield select(getGroupId);

    // update standard lead time
    yield call(API.groups.updateUserGroup, groupId, {
      standard_lead_time_template: standardLeadTime,
    });
    // reload the users profile to include updated standard lead time
    yield put(fetchProfile.request());

    // update expedites
    const oldExpedites = yield select(getGlobalExpediteOptions);
    for (let i = 0; i < 3; i++) {
      const curr = expediteOptions[i];
      const old = oldExpedites[i];
      if (curr !== old) {
        if (isCompleteExpedite(curr))
          curr.id
            ? yield call(quoteService.updateGlobalExpediteOption, curr.id, curr)
            : yield call(
                quoteService.createGlobalExpediteOption,
                groupId,
                curr,
              );
        else if (curr.id)
          yield call(quoteService.deleteGlobalExpediteOption, curr.id);
      }
    }
    const globalExpediteOptions = yield call(
      quoteService.getGlobalExpediteOptions,
      groupId,
    );
    yield put(
      updateExpediteSettings.success({
        globalExpediteOptions,
      }),
    );
  } catch (error) {
    yield put(updateExpediteSettings.error(error));
  }
}

export function* initSaga() {
  yield all([watchFetchGlobalExpediteOptions()]);
}
